import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesDisclaimerAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesDisclaimer() {
  return fetchApi('/v1/fc_api/feeding_guidelines_disclaimer_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesDisclaimer;
